import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, ButtonProps, Theme } from '@mui/material';
import { MdAdd as AddIcon } from 'react-icons/md';
import { important } from 'common-types';

const AddOwnerButton: FC<React.PropsWithChildren<AddOwnerButtonProps>> = ({
  onClick,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Button
      startIcon={<AddIcon />}
      color='primary'
      size='small'
      variant='text'
      {...props}
      className={classes.addOwner}
      onClick={onClick}>
      Add owner
    </Button>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  addOwner: {
    textTransform: important('none'),
    fontSize: important(`${theme.typography.body2.fontSize}`),
    whiteSpace: 'nowrap',
  },
}));

export interface AddOwnerButtonProps extends ButtonProps {
  onClick: () => void;
}

export default AddOwnerButton;
